import { useDiscountData } from "@chef/state-management/hooks";
import { Hr } from "@chef/components";

import { Discount } from "./Discount";

interface PermanentDiscountProps {
  hasDivider?: boolean;
}

export const PermanentDiscount = ({
  hasDivider = true,
}: PermanentDiscountProps) => {
  const {
    discounts: {
      activeDiscounts: { permanentDiscounts },
    },
  } = useDiscountData();

  const { nextPermanentDiscount } = permanentDiscounts;

  if (!nextPermanentDiscount) {
    return null;
  }

  return (
    <>
      {hasDivider && <Hr className="my-4" />}
      <Discount discount={nextPermanentDiscount} type="permanent" />
    </>
  );
};
